module.exports = __webpack_public_path__ + "img/menu_item_bk.2cfc2d37.png";